
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/go-to-sources",
      function () {
        return require("private-next-pages/stories/go-to-sources.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/go-to-sources"])
      });
    }
  